import { useState, useEffect } from "react";

export const ANCHO_MOVIL = 1000;

const useEsMovil = () => {
    const [esMovil, setEsMovil] = useState(() => window.innerWidth <= ANCHO_MOVIL);

    useEffect(() => {
        let timeout;
        const alRedimensionar = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setEsMovil(window.innerWidth <= ANCHO_MOVIL), 200);
        };
        window.addEventListener("resize", alRedimensionar);
        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", alRedimensionar);
        };
    }, []);

    return esMovil;
};

export default useEsMovil;
